var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_43",
    "data-name": "Group 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.459,
    height: 64.711,
    viewBox: "0 0 47.459 64.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3515",
    "data-name": "Rectangle 3515",
    width: 47.459,
    height: 64.711,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M47.459,17.252a2.121,2.121,0,0,0-.932-1.763L24.955.388a2.127,2.127,0,0,0-2.451,0L.932,15.489a2.134,2.134,0,0,0,0,3.526l9.854,6.866v2.393A12.957,12.957,0,0,0,15.1,37.835a12.1,12.1,0,0,0,1.056.8v2.347H15.1A15.106,15.106,0,0,0,0,56.082V58.24a6.474,6.474,0,0,0,6.472,6.472H40.988a6.474,6.474,0,0,0,6.472-6.472V56.082a15.106,15.106,0,0,0-15.1-15.1H31.168V38.825a13.634,13.634,0,0,0,5.505-10.976V25.881l6.472-4.527v6.685a2.157,2.157,0,1,0,4.314,0Zm-15.1,4.9a48.459,48.459,0,0,0-17.258,0V17.836a42.132,42.132,0,0,1,17.258,0ZM43.145,56.082V58.24A2.158,2.158,0,0,1,40.988,60.4H6.472A2.158,2.158,0,0,1,4.314,58.24V56.082A10.79,10.79,0,0,1,15.1,45.3h1.125a7.527,7.527,0,0,0,14.819,0h1.314A10.79,10.79,0,0,1,43.145,56.082M26.853,43.959a3.236,3.236,0,1,1-6.472,0V40.746a12.793,12.793,0,0,0,3.371.495,11.246,11.246,0,0,0,1.245,0,9.681,9.681,0,0,0,1.855-.348ZM24.6,36.88A8.621,8.621,0,0,1,15.1,28.251v-1.74a42.842,42.842,0,0,1,17.258,0v1.268a8.931,8.931,0,0,1-7.763,9.1M36.673,20.658V16.343a2.159,2.159,0,0,0-1.527-2.157,45.676,45.676,0,0,0-22.832,0,2.159,2.159,0,0,0-1.527,2.157v4.314L5.911,17.252,23.73,4.78,41.548,17.252Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveIcon);
export default __webpack_public_path__ + "static/media/receive-icon.258d9da2712c9f6daed99eb133faead9.svg";
export { ForwardRef as ReactComponent };